var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-success btn-sm pull-right mr-2",on:{"click":_vm.approve}},[_vm._v("\n    "+_vm._s(_vm.$t('measurement.BtnApprove'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }